import { EGDSSpacing } from '@egds/react-core/spacing';
import * as React from 'react';
import { LocalizedText } from '@shared-ui/localization-context';
import { SharedUiLodgingOneKeyBurnSwitchWrapper } from '../shared-ui/offers/lodging-one-key-burn-switch-wrapper';
import { SharedUiSingleUnitForm } from '../shared-ui/form/shared-ui-forms';
export const SearchWizardComposer = ({
  navigateTo,
  onUpdateResults
}) => React.createElement(EGDSSpacing, {
  padding: {
    block: 'three'
  }
}, React.createElement("div", {
  "data-stid": "single-offer-search"
}, React.createElement("h3", {
  className: "is-visually-hidden"
}, React.createElement(LocalizedText, {
  message: 'hotels.infosite.availabilityWizard.changeSearch.a11yLabel'
})), React.createElement(SharedUiSingleUnitForm, {
  onSubmit: navigateTo,
  onChange: onUpdateResults
}), React.createElement(SharedUiLodgingOneKeyBurnSwitchWrapper, {
  showBorder: true
})));
SearchWizardComposer.displayName = 'SearchWizardComposer';